export default __webpack_public_path__ + "static/media/svg-Consulta.95a90637.svg";